import React from "react";

export const Illustration3 = () => {
	return (
		<svg width={442} height={223} viewBox="0 0 442 223" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M23.7454 62.2392C-9.66369 156.052 24.6827 177.846 54.0714 221H394.427C439.352 170.289 438.451 98.8251 420.421 56.3387C397.25 1.739 373.798 -1.79292 297.023 15.3747C255.001 24.7712 207.148 26.0204 182.439 15.8784C157.73 5.73634 57.1546 -31.5739 23.7454 62.2392Z"
				fill="#F5FAFF"
			/>
			<path
				d="M280 111H361C363.209 111 365 112.791 365 115V221H276V115C276 112.791 277.791 111 280 111Z"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M69 142H138C140.209 142 142 143.791 142 146V221H65V146C65 143.791 66.7909 142 69 142Z"
				fill="#F5FAFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M143 57.0001H277C279.209 57.0001 281 58.7909 281 61.0001V221H139V61.0001C139 58.7909 140.791 57.0001 143 57.0001Z"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M166 73.0001H255C257.209 73.0001 259 74.7909 259 77.0001V221H162V77.0001L162.005 76.794C162.112 74.6806 163.86 73.0001 166 73.0001Z"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<line x1={172} y1={98.0001} x2={224} y2={98.0001} stroke="#C4DBF1" strokeWidth={2} />
			<line x1={111} y1={171.5} x2={138} y2={171.5} stroke="#C4DBF1" strokeWidth={5} />
			<line x1={111} y1={187.5} x2={138} y2={187.5} stroke="#C4DBF1" strokeWidth={5} />
			<line x1={75} y1={201.5} x2={138} y2={201.5} stroke="#C4DBF1" strokeWidth={5} />
			<line x1={172} y1={190} x2={231} y2={190} stroke="#C4DBF1" strokeWidth={2} />
			<line x1={172} y1={208} x2={247} y2={208} stroke="#C4DBF1" strokeWidth={2} />
			<line x1={188} y1={151} x2={228} y2={151} stroke="#C4DBF1" strokeWidth={4} />
			<line x1={172} y1={109} x2={201} y2={109} stroke="#C4DBF1" strokeWidth={2} />
			<mask id="path-14-inside-1_13119_567" fill="white">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M209.504 46.0001C203.981 46.0001 199.504 50.4772 199.504 56.0001V59.3428H181.104C175.582 59.3428 171.104 63.8199 171.104 69.3428V83.4863H248.35V69.3428C248.35 63.8199 243.872 59.3428 238.35 59.3428H219.951V56.0001C219.951 50.4772 215.474 46.0001 209.951 46.0001H209.504Z"
				/>
			</mask>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M209.504 46.0001C203.981 46.0001 199.504 50.4772 199.504 56.0001V59.3428H181.104C175.582 59.3428 171.104 63.8199 171.104 69.3428V83.4863H248.35V69.3428C248.35 63.8199 243.872 59.3428 238.35 59.3428H219.951V56.0001C219.951 50.4772 215.474 46.0001 209.951 46.0001H209.504Z"
				fill="#E0EAF4"
			/>
			<path
				d="M199.504 59.3428V61.3428H201.504V59.3428H199.504ZM171.104 69.3428L169.104 69.3428V69.3428H171.104ZM171.104 83.4863H169.104V85.4863H171.104V83.4863ZM248.35 83.4863V85.4863H250.35V83.4863H248.35ZM219.951 59.3428H217.951V61.3428H219.951V59.3428ZM199.504 56.0001H201.504C201.504 51.5818 205.085 48.0001 209.504 48.0001V46.0001V44.0001C202.876 44.0001 197.504 49.3726 197.504 56.0001H199.504ZM199.504 59.3428H201.504V56.0001H199.504H197.504V59.3428H199.504ZM181.104 59.3428V61.3428H199.504V59.3428V57.3428H181.104V59.3428ZM171.104 69.3428L173.104 69.3428C173.104 64.9245 176.686 61.3428 181.104 61.3428V59.3428V57.3428C174.477 57.3428 169.104 62.7154 169.104 69.3428L171.104 69.3428ZM171.104 83.4863H173.104V69.3428H171.104H169.104V83.4863H171.104ZM248.35 83.4863V81.4863H171.104V83.4863V85.4863H248.35V83.4863ZM248.35 69.3428H246.35V83.4863H248.35H250.35V69.3428H248.35ZM238.35 59.3428V61.3428C242.768 61.3428 246.35 64.9245 246.35 69.3428H248.35H250.35C250.35 62.7154 244.977 57.3428 238.35 57.3428V59.3428ZM219.951 59.3428V61.3428H238.35V59.3428V57.3428H219.951V59.3428ZM219.951 56.0001H217.951V59.3428H219.951H221.951V56.0001H219.951ZM209.951 46.0001V48.0001C214.369 48.0001 217.951 51.5818 217.951 56.0001H219.951H221.951C221.951 49.3726 216.578 44.0001 209.951 44.0001V46.0001ZM209.504 46.0001V48.0001H209.951V46.0001V44.0001H209.504V46.0001Z"
				fill="#315C84"
				mask="url(#path-14-inside-1_13119_567)"
			/>
			<line x1={173} y1={73.074} x2={247} y2={73.074} stroke="#315C84" strokeWidth={2} />
			<path
				d="M115.757 114.295L146.307 127.189L152.603 124.581L149.95 118.177L119.416 105.291L115.757 114.295ZM110.132 101.374C109.522 101.117 108.837 101.401 108.588 102.014L105.834 108.789C105.581 109.411 105.878 110.127 106.497 110.388L110.833 112.218L114.493 103.214L110.132 101.374Z"
				fill="#F5FAFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<circle
				cx={88.3702}
				cy={174.37}
				r={13.6298}
				transform="rotate(7.30037 88.3702 174.37)"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M86.2001 180.956L80.9 175.577C80.5815 175.254 80.562 174.712 80.8562 174.367L81.922 173.116C82.2163 172.771 82.713 172.753 83.0314 173.076L86.6019 176.7L93.6697 168.407C93.9639 168.062 94.4607 168.044 94.7791 168.367L95.9323 169.538C96.2507 169.861 96.2702 170.403 95.976 170.748L87.3096 180.916C87.0153 181.261 86.5185 181.279 86.2001 180.956Z"
				fill="#C4DBF1"
			/>
			<line x1={171} y1={127.5} x2={247} y2={127.5} stroke="#86ACCF" strokeOpacity={0.22} />
			<circle cx={177.5} cy={127.5} r={4.5} fill="#C4DBF1" />
			<circle cx={177} cy={151} r={4} stroke="#C4DBF1" strokeOpacity={0.49} strokeWidth={2} />
			<line x1={188} y1={171} x2={228} y2={171} stroke="#C4DBF1" strokeWidth={4} />
			<circle cx={177} cy={171} r={4} stroke="#C4DBF1" strokeOpacity={0.49} strokeWidth={2} />
			<circle cx={198.5} cy={127.5} r={4.5} fill="#C4DBF1" />
			<circle cx={218.5} cy={127.5} r={4.5} fill="#C4DBF1" />
			<circle cx={239.5} cy={127.5} r={4.5} fill="#C4DBF1" />
			<line x1={43} y1={221} x2={411} y2={221} stroke="#315C84" strokeWidth={2} />
			<line x1={293} y1={90.0001} x2={301} y2={90.0001} stroke="#315C84" strokeWidth={2} />
			<line x1={297} y1={86.0001} x2={297} y2={94.0001} stroke="#315C84" strokeWidth={2} />
			<line x1={35} y1={160} x2={43} y2={160} stroke="#315C84" strokeWidth={2} />
			<line x1={39} y1={156} x2={39} y2={164} stroke="#315C84" strokeWidth={2} />
			<line x1={40} y1={27.0001} x2={48} y2={27.0001} stroke="#315C84" strokeWidth={2} />
			<line x1={44} y1={23.0001} x2={44} y2={31.0001} stroke="#315C84" strokeWidth={2} />
			<line x1={391} y1={200} x2={399} y2={200} stroke="#315C84" strokeWidth={2} />
			<line x1={395} y1={196} x2={395} y2={204} stroke="#315C84" strokeWidth={2} />
			<line x1={288} y1={125} x2={328} y2={125} stroke="#C4DBF1" strokeWidth={4} />
			<line x1={288} y1={142} x2={352} y2={142} stroke="#C4DBF1" strokeWidth={4} />
			<line x1={288} y1={159} x2={352} y2={159} stroke="#C4DBF1" strokeWidth={4} />
			<rect x={288} y={176} width={66} height={31} rx={3} fill="#C4DBF1" fillOpacity={0.49} />
			<rect x={288} y={176} width={66} height={31} rx={3} stroke="#C4DBF1" />
			<ellipse
				cx={101.316}
				cy={64.0022}
				rx={28.5069}
				ry={28.0814}
				transform="rotate(-13.6135 101.316 64.0022)"
				fill="#F9FCFF"
			/>
			<circle
				cx={101.416}
				cy={64.4157}
				r={23.2521}
				transform="rotate(-13.6135 101.416 64.4157)"
				fill="#C4DBF1"
				fillOpacity={0.49}
				stroke="#315C84"
				strokeWidth={2}
			/>
			<mask id="path-43-inside-2_13119_567" fill="white">
				<path d="M95.7073 40.845C108.725 37.6924 121.834 45.6897 124.986 58.7074C127.007 67.0523 124.446 75.4342 118.918 81.2072L117.559 75.5941C116.453 71.0303 112.381 67.9642 107.886 67.9468C110.262 65.5029 111.371 61.9321 110.51 58.3748C109.176 52.8673 103.63 49.4837 98.1224 50.8174C92.615 52.1513 89.2312 57.6975 90.565 63.205C91.4265 66.7618 94.0461 69.4299 97.2762 70.5163C93.2884 72.5883 91.0701 77.1778 92.1753 81.7413L93.5346 87.3544C85.978 84.7502 79.8658 78.4685 77.8449 70.1238C74.6925 57.1061 82.6897 43.9976 95.7073 40.845Z" />
			</mask>
			<path
				d="M95.7073 40.845C108.725 37.6924 121.834 45.6897 124.986 58.7074C127.007 67.0523 124.446 75.4342 118.918 81.2072L117.559 75.5941C116.453 71.0303 112.381 67.9642 107.886 67.9468C110.262 65.5029 111.371 61.9321 110.51 58.3748C109.176 52.8673 103.63 49.4837 98.1224 50.8174C92.615 52.1513 89.2312 57.6975 90.565 63.205C91.4265 66.7618 94.0461 69.4299 97.2762 70.5163C93.2884 72.5883 91.0701 77.1778 92.1753 81.7413L93.5346 87.3544C85.978 84.7502 79.8658 78.4685 77.8449 70.1238C74.6925 57.1061 82.6897 43.9976 95.7073 40.845Z"
				fill="#F9FCFF"
			/>
			<path
				d="M95.7073 40.845L95.2366 38.9012L95.2366 38.9012L95.7073 40.845ZM124.986 58.7074L126.93 58.2367L126.93 58.2366L124.986 58.7074ZM118.918 81.2072L116.974 81.6779L117.835 85.2304L120.363 82.5904L118.918 81.2072ZM117.559 75.5941L119.503 75.1233L119.503 75.1233L117.559 75.5941ZM107.886 67.9468L106.452 66.5527L103.171 69.9286L107.879 69.9468L107.886 67.9468ZM110.51 58.3748L112.454 57.9042L112.454 57.9041L110.51 58.3748ZM98.1224 50.8174L97.6517 48.8736L97.6516 48.8736L98.1224 50.8174ZM90.565 63.205L88.6212 63.6757L88.6212 63.6758L90.565 63.205ZM97.2762 70.5163L98.1983 72.2911L102.375 70.1211L97.9138 68.6207L97.2762 70.5163ZM92.1753 81.7413L90.2315 82.212L90.2315 82.212L92.1753 81.7413ZM93.5346 87.3544L92.883 89.2453L96.3388 90.4362L95.4785 86.8837L93.5346 87.3544ZM77.8449 70.1238L75.9011 70.5945L75.9011 70.5945L77.8449 70.1238ZM95.7073 40.845L96.1781 42.7888C108.122 39.8962 120.15 47.234 123.042 59.1781L124.986 58.7074L126.93 58.2366C123.517 44.1454 109.328 35.4886 95.2366 38.9012L95.7073 40.845ZM124.986 58.7074L123.042 59.1781C124.896 66.8327 122.55 74.5226 117.474 79.824L118.918 81.2072L120.363 82.5904C126.342 76.3458 129.118 67.2718 126.93 58.2367L124.986 58.7074ZM118.918 81.2072L120.862 80.7365L119.503 75.1233L117.559 75.5941L115.615 76.0648L116.974 81.6779L118.918 81.2072ZM117.559 75.5941L119.503 75.1233C118.176 69.6438 113.287 65.9677 107.894 65.9468L107.886 67.9468L107.879 69.9468C111.475 69.9607 114.731 72.4167 115.615 76.0648L117.559 75.5941ZM107.886 67.9468L109.321 69.3408C112.154 66.426 113.484 62.1582 112.454 57.9042L110.51 58.3748L108.566 58.8455C109.259 61.7059 108.37 64.5798 106.452 66.5527L107.886 67.9468ZM110.51 58.3748L112.454 57.9041C110.86 51.323 104.233 47.2799 97.6517 48.8736L98.1224 50.8174L98.5931 52.7613C103.027 51.6875 107.492 54.4116 108.566 58.8456L110.51 58.3748ZM98.1224 50.8174L97.6516 48.8736C91.0707 50.4674 87.0274 57.0947 88.6212 63.6757L90.565 63.205L92.5088 62.7343C91.435 58.3003 94.1592 53.8351 98.5932 52.7613L98.1224 50.8174ZM90.565 63.205L88.6212 63.6758C89.6515 67.9292 92.7858 71.1161 96.6386 72.412L97.2762 70.5163L97.9138 68.6207C95.3063 67.7437 93.2016 65.5943 92.5088 62.7342L90.565 63.205ZM97.2762 70.5163L96.3541 68.7416C91.5691 71.2277 88.9046 76.733 90.2315 82.212L92.1753 81.7413L94.1191 81.2705C93.2357 77.6226 95.0076 73.9488 98.1983 72.2911L97.2762 70.5163ZM92.1753 81.7413L90.2315 82.212L91.5908 87.8252L93.5346 87.3544L95.4785 86.8837L94.1191 81.2705L92.1753 81.7413ZM93.5346 87.3544L94.1863 85.4635C87.247 83.0721 81.6424 77.3075 79.7887 69.653L77.8449 70.1238L75.9011 70.5945C78.0891 79.6295 84.709 86.4283 92.883 89.2453L93.5346 87.3544ZM77.8449 70.1238L79.7887 69.653C76.8962 57.7089 84.234 45.6814 96.1781 42.7888L95.7073 40.845L95.2366 38.9012C81.1454 42.3138 72.4887 56.5033 75.9011 70.5945L77.8449 70.1238Z"
				fill="#315C84"
				mask="url(#path-43-inside-2_13119_567)"
			/>
			<line x1={62.9261} y1={61.5896} x2={70.847} y2={61.0028} stroke="#315C84" strokeWidth={2} />
			<line x1={62.3846} y1={44.077} x2={74.3846} y2={49.077} stroke="#315C84" strokeWidth={2} />
			<line x1={75.8664} y1={32.5007} x2={80.5274} y2={40.5869} stroke="#315C84" strokeWidth={2} />
			<circle cx={47.5} cy={101.5} r={2.5} stroke="#315C84" strokeWidth={2} />
			<circle cx={169.5} cy={27.5001} r={2.5} stroke="#315C84" strokeWidth={2} />
			<circle cx={411.5} cy={147.5} r={2.5} stroke="#315C84" strokeWidth={2} />
			<circle cx={334} cy={49.0001} r={5} stroke="#315C84" strokeWidth={2} />
			<circle
				cx={391.5}
				cy={86.5001}
				r={4.5}
				fill="#C4DBF1"
				fillOpacity={0.49}
				stroke="#315C84"
				strokeWidth={2}
			/>
		</svg>
	);
};
